import React, { memo } from 'react';
import { useLocationStore, useTranslation } from 'mycheck-core';
import styles from '../../OrderStatusPage.module.scss';

const OrderRestaurantDetails = () => {
  const LocationStore = useLocationStore();
  const { t } = useTranslation();

  const { name, phone } = LocationStore.selectedRestaurant;

  return (
    <div className={styles.orderStatusPageRestaurantDetailsSection}>
      <div className={styles.orderStatusPageNotificationSectionTitle}>
        {t('orderStatus.restaurantDetailsTitle')}
      </div>
      <div className={styles.orderStatusPageSectionSubtitle}>{name}</div>
      <div className={styles.orderStatusPageSectionSubtitle}>{phone}</div>
    </div>
  );
};

export default memo(OrderRestaurantDetails);
